import {
  useSavedViewConfiguration,
  useSavedViewConfigurationActions,
  useSavedViewConfigurationDirtyState,
} from '../../contexts/views/SavedViewConfigurationProvider'
import {SavedViewOptionsMenu} from './SavedViewOptionsMenu'
import {useSavedViewFields} from './use-saved-view-fields'

/** The view options menu, connected to the saved view configuration and its fields. */
export function ConnectedSavedViewOptionsMenu({basePath, disabled = false}: {basePath: string; disabled?: boolean}) {
  const {data: fields, isError, isPending} = useSavedViewFields(basePath)
  const configuration = useSavedViewConfiguration()
  const {applyConfiguration} = useSavedViewConfigurationActions()
  const {dirty, isConfigurationDirty} = useSavedViewConfigurationDirtyState()

  return (
    <SavedViewOptionsMenu
      fields={fields}
      isPending={isPending}
      isError={isError}
      configuration={configuration}
      disabled={disabled}
      showDirtyIndicator={isConfigurationDirty}
      configurationDirty={dirty}
      onApply={applyConfiguration}
    />
  )
}
